import moment from 'moment';

export const sortDates = (field, direction, a, b) => (
  direction === 'DESC' ?
    moment(new Date(b[field])).diff(moment(new Date(a[field]))) :
    moment(new Date(a[field])).diff(moment(new Date(b[field])))
);

export const sortAlpha = (field, direction, a, b) => {
  if (direction === 'DESC') {
    return b[field] ? b[field].localeCompare(a[field]) : -1;
  }
  return a[field] ? a[field].localeCompare(b[field]) : -1;
};

export const sortNumeric = (field, direction, a, b) => {
  if (direction === 'DESC') {
    return b[field] ? b[field] - (a[field]) : -1;
  }
  return a[field] ? a[field] - (b[field]) : -1;
};

export const sortHtml = (field, direction, a, b) => {
  if (!a[field]) {
    return direction === 'DESC';
  }
  if (!b[field]) {
    return direction !== 'DESC';
  }
  const left = a[field].split('<br />')[0].trim();
  const right = b[field].split('<br />')[0].trim();
  return direction === 'DESC' ? right.localeCompare(left) : left.localeCompare(right);
};
